import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { LightboxProvider } from './components/Lightbox.jsx';
import { ConsentProvider } from './components/Consent.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <LightboxProvider>
        <ConsentProvider>
          <App />
        </ConsentProvider>
      </LightboxProvider>
    </BrowserRouter>
  </React.StrictMode>
);
